import Vue from 'vue'
export const BgActionEventBus = new Vue()